import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent } from './ui/card';
import { CLINIC_HIGHLIGHTS } from '../constants/clinicData';
import { useTranslation } from 'react-i18next';

const AboutClinic = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  return (
    <section id="about" className="py-20 px-4 bg-gradient-to-br from-white via-emerald-50/30 to-white" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          {t('about.title')}
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-lg text-slate-700 leading-relaxed mb-6 scroll-reveal" 
            style={{ animationDelay: '0.2s' }}
          >
            Welcome to <strong className="font-bold">Tonge Healthcare</strong> - recognized as a <strong>leading medical clinic in Chandrapur and Vidarbha region</strong>. Led by <strong>Dr. Nikhil Tonge, MD General Medicine</strong>, we are your trusted healthcare partner specializing in Diabetes Management, Hypertension Treatment, Thyroid Care, Cardiac Evaluation, Respiratory Diseases, and Rheumatology.
          </p>
          <p className="text-lg text-slate-700 leading-relaxed mb-6 scroll-reveal" style={{ animationDelay: '0.3s' }}>
            As an <strong>expert diabetologist and physician in Chandrapur</strong>, we offer comprehensive internal medicine services including expert treatment for diabetes (with advanced medications like Mounjaro and Ozempic when required), high blood pressure, thyroid disorders, heart conditions, asthma, COPD, arthritis, fever, infectious diseases, and weight management.
          </p>
          <p className="text-lg text-slate-700 leading-relaxed scroll-reveal" style={{ animationDelay: '0.4s' }}>
            Our evidence-based, patient-centered approach combines clinical expertise with modern diagnostics and AI-enhanced decision-making. Whether you need treatment for chronic diseases, preventive health checkups, or emergency care, Tonge Healthcare is your <strong>trusted choice for quality medical care in Chandrapur, Maharashtra</strong>.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {CLINIC_HIGHLIGHTS.map((item, index) => {
            const Icon = item.icon;
            return (
              <Card 
                key={item.title} 
                className="card-hover scroll-reveal-scale border-0 shadow-lg bg-white/60 backdrop-blur-sm" 
                style={{ 
                  animationDelay: `${0.4 + index * 0.1}s`,
                  boxShadow: '0 4px 20px rgba(5, 56, 39, 0.08)'
                }}
              >
                <CardContent className="pt-6 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4 shadow-md" 
                    style={{ 
                      background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)'
                    }}
                  >
                    <Icon style={{ color: 'var(--medical-primary)' }} size={32} />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-2">{t(`about.${item.titleKey}`)}</h3>
                  <p className="text-slate-600">{t(`about.${item.descKey}`)}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutClinic;